import { render } from "./IndexWarehousePage.vue?vue&type=template&id=18e8f86a"
import script from "./IndexWarehousePage.vue?vue&type=script&lang=js"
export * from "./IndexWarehousePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__